import { render, staticRenderFns } from "./VisitBox.vue?vue&type=template&id=19502b5e&scoped=true&"
import script from "./VisitBox.vue?vue&type=script&lang=js&"
export * from "./VisitBox.vue?vue&type=script&lang=js&"
import style0 from "./VisitBox.vue?vue&type=style&index=0&id=19502b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19502b5e",
  null
  
)

export default component.exports